import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import cn from 'classnames';

import './brHoverSpanTable.scss';

/* eslint-disable react/no-array-index-key */
export default class BrHoverSpanTable extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    cols: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        title: PropTypes.string,
        width: PropTypes.string,
      }),
    ).isRequired,
    rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  };

  computeWidthStyle = (width) => {
    if (width) {
      return { width };
    }
    return { flex: '1 1' };
  };

  generateDataRowGrid = (row, cols) => {
    const domArr = [];
    cols.forEach((col, idx) => {
      if (Array.isArray(row[col.key])) {
        row[col.key].forEach((cell, idy) => {
          domArr.push(
            <div key={`${idx}-${idy}`} className="data-cell" style={{ gridColumn: idx + 1, gridRow: idy + 1 }}>
              {cell}
            </div>,
          );
        });
      } else {
        domArr.push(
          <div key={idx} className="data-cell" style={{ gridColumn: idx + 1, gridRow: '1 / last' }}>
            {row[col.key]}
          </div>,
        );
      }
    });
    return domArr;
  };

  generateDataRowGridTemplate = (row, cols) => {
    const rows = 'auto '.repeat(
      Math.max(...cols.map((col) => (Array.isArray(row[col.key]) ? row[col.key].length : 1))),
    );
    return {
      gridTemplateColumns: cols.map((col) => col.width || 'auto').join(' '),
      gridTemplateRows: rows,
    };
  };

  render() {
    const { cols, rows, className } = this.props;
    const classname = cn('br-hover-span-table', className);

    return (
      <div className={classname}>
        <div className="col-titles">
          {cols.map((col, idx) => (
            <div key={idx} className="col-title" title={col.title} style={this.computeWidthStyle(col.width)}>
              {col.title}
            </div>
          ))}
        </div>
        <div className="data-rows">
          {rows.map((row, idx) => (
            <div key={idx} className="data-row" style={this.generateDataRowGridTemplate(row, cols)}>
              {this.generateDataRowGrid(row, cols)}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
